import { Button, useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { useAPI } from "../api/useAPI";
import { AppPage } from "../utils/AppPage";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { useBehaviorSubjectState } from "../utils/useBehaviorSubjectState";

export const SettingsPage = () => {
  const toast = useToast();
  const api = useAPI();
  const [notificationPermission] = useBehaviorSubjectState(
    api.notificationPermission$
  );

  const onNotificationsSubscribe = useCallback(() => {
    if (!("Notification" in window)) {
      toast({
        status: "error",
        title: "This browser does not support notifications.",
      });
      return;
    }
    api.requestNotificationPermission();
  }, [api, toast]);

  return (
    <AppPage
      title="Settings"
      display={"flex"}
      flexDir={"column"}
      alignItems={"center"}
    >
      <Button
        colorScheme={THEME_COLOR_SCHEME}
        onClick={onNotificationsSubscribe}
        isDisabled={notificationPermission === "granted"}
      >
        Subscribe to notifications
      </Button>
    </AppPage>
  );
};
